/* Rebel motion layer. Deferred, ~1 KB, respects reduced motion.
   Powers: M3 scroll reveals, M5 spin the book, M6 the easter egg.
   Everything else in the motion vocabulary is pure CSS in rebel-tokens.css. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* M3: reveal on scroll */
  var els = Array.prototype.slice.call(document.querySelectorAll('.rebel-reveal'));
  if (reduce || !('IntersectionObserver' in window)) {
    els.forEach(function (e) { e.classList.add('in'); });
  } else if (els.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.15 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* M5: spin on tap */
  document.querySelectorAll('.rebel-spinnable').forEach(function (box) {
    if (reduce) return;
    function go() { box.classList.remove('go'); void box.offsetWidth; box.classList.add('go'); }
    box.addEventListener('click', go);
    box.addEventListener('animationend', function () { box.classList.remove('go'); });
  });

  /* M6: the easter egg is just an element with .rebel-egg, no JS needed.
     Here we only enforce the rule: never on a product (buy) template. */
  if (document.body.classList.contains('template-product')) {
    document.querySelectorAll('.rebel-egg').forEach(function (e) { e.remove(); });
  }
})();
